import React, { Fragment, useState, useEffect } from 'react'
import { NavLink as RNavLink, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { Nav, Button } from 'react-bootstrap'
import styles from './style.module.scss'

export type ListItemType = {
  badge?: boolean
  disabled?: boolean
  label: string
  href: string
  icon?: React.ReactNode
  selected?: boolean
  subItems?: ListItemType[]
}
type IPropsItem = {
  item: ListItemType
}
type IProps = {
  list: ListItemType[]
}
const MenuItem = React.memo(({ item }: IPropsItem) => {
  if (item.disabled) return <Fragment />
  const Component = !(item.subItems === undefined || item.subItems.constructor !== Array || item.subItems.length === 0)
    ? MultiLevel
    : SingleLevel
  return <Component item={item} />
})
const SingleLevel = React.memo(({ item }: IPropsItem) => {
  const { href, icon, label } = item
  return (
    <Nav.Item className={styles['nav-item']}>
      <Nav.Link as={RNavLink} exact to={href} className={styles['nav-link']} activeClassName={styles['active']}>
        {icon && <div className={styles['icon']}>{icon}</div>}
        <span>{label}</span>
      </Nav.Link>
    </Nav.Item>
  )
})
const MultiLevel = React.memo(({ item }: IPropsItem) => {
  const { subItems, icon, label, selected } = item
  const [open, setOpen] = useState<boolean>(selected ? selected : false)
  const location = useLocation()
  useEffect(() => {
    if (subItems) {
      subItems.map((item) => {
        if (item.href === location.pathname) {
          setOpen(true)
        }
        return false
      })
    }
    return () => {
      setOpen(false)
    }
  }, [subItems, location])
  const handleClick = () => {
    setOpen((prev) => !prev)
  }
  if (!subItems) return null
  return (
    <Fragment>
      <Nav.Item className={styles['nav-item']}>
        <Nav.Link
          as={Button}
          variant="none"
          className={classNames(styles['nav-link'], { [styles['active']]: open }, 'w-100')}
          onClick={handleClick}
        >
          {icon && <div className={styles['icon']}>{icon}</div>}
          <span>{label}</span>
          {!open ? (
            <i className={classNames(styles['expand'], 'ms-auto material-icons')}>chevron_right</i>
          ) : (
            <i className={classNames(styles['expand'], 'ms-auto material-icons')}>expand_more</i>
          )}
        </Nav.Link>
      </Nav.Item>
      <div className={classNames(styles['according'], { [styles['show']]: open }, 'ps-3')}>
        <Fragment>
          {subItems.map((child, key) => (
            <MenuItem key={key} item={child} />
          ))}
        </Fragment>
      </div>
    </Fragment>
  )
})

const CustomNav = React.memo(({ list }: IProps) => {
  return (
    <Nav className="flex-column" bsPrefix={styles['nav']}>
      {list.map((item, index) => (
        <MenuItem item={item} key={index} />
      ))}
    </Nav>
  )
})

export default CustomNav
